/**
 * mc-quick-add.js — Manifesto
 *
 * Stepper (− qty +) + "Adicionar" nos cards de produto (mc-product-card),
 * replicando o ProductCard.tsx. Add-to-cart é AJAX (/cart/add.js) e abre a
 * gaveta lateral (cart-drawer) reusando renderContents() — mesmo caminho do
 * product-form.js do Dawn. Funciona também em cards adicionados via "Ver mais"
 * (listeners delegados no document).
 */

(function () {
  'use strict';

  function qtyInput(card) {
    return card ? card.querySelector('[data-mc-qty]') : null;
  }

  function clampQty(input) {
    var v = parseInt(input.value, 10);
    if (isNaN(v) || v < 1) v = 1;
    input.value = String(v);
    return v;
  }

  // ── Badge "N no carrinho" nos cards ──
  // Espelha o ProductCard.tsx: círculo accent no canto da imagem com a qty
  // já no carrinho daquele variant. Atualiza no add e em qualquer cart-update
  // (ex.: remoção na gaveta).
  function updateCartBadges(items) {
    var counts = {};
    (items || []).forEach(function (it) {
      var k = String(it.variant_id);
      counts[k] = (counts[k] || 0) + it.quantity;
    });
    document.querySelectorAll('[data-mc-cart-badge]').forEach(function (badge) {
      var n = counts[String(badge.getAttribute('data-variant-id'))] || 0;
      badge.textContent = n;
      badge.setAttribute('aria-label', n + ' no carrinho');
      badge.classList.toggle('is-empty', n === 0);
    });
  }
  function syncCartBadges(event) {
    if (event && event.cartData && event.cartData.items) {
      updateCartBadges(event.cartData.items);
      return;
    }
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) { if (cart) updateCartBadges(cart.items); })
      .catch(function () {});
  }

  // Região aria-live única para anunciar feedback (erro/parcial) a leitores de
  // tela — a troca de textContent do botão sozinha não é anunciada em fluxo AJAX.
  function announce(text) {
    var region = document.getElementById('mc-quick-add-status');
    if (!region) {
      region = document.createElement('div');
      region.id = 'mc-quick-add-status';
      region.className = 'visually-hidden';
      region.setAttribute('role', 'status');
      region.setAttribute('aria-live', 'polite');
      document.body.appendChild(region);
    }
    region.textContent = text;
  }

  // Feedback temporário no botão, restaurando o rótulo original guardado.
  function flash(button, text, ms) {
    button.textContent = text;
    announce(text);
    setTimeout(function () {
      button.textContent = button.dataset.mcLabel || button.textContent;
    }, ms || 1600);
  }

  // POST /cart/add.js com as sections da gaveta. Resolve com o JSON da resposta
  // (objeto de item no sucesso; objeto com .status no erro 422).
  function performAdd(variantId, qty, cart) {
    var formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', String(qty));
    if (cart && typeof cart.getSectionsToRender === 'function') {
      formData.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }).join(','));
      formData.append('sections_url', window.location.pathname);
      if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
    }
    var addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';
    return fetch(addUrl, {
      method: 'POST',
      headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: formData,
    }).then(function (r) { return r.json(); });
  }

  // Conta quantas unidades do variant já estão no carrinho.
  function inCartQty(cartData, variantId) {
    var n = 0;
    if (cartData && cartData.items) {
      cartData.items.forEach(function (it) {
        if (String(it.variant_id) === String(variantId)) n += it.quantity;
      });
    }
    return n;
  }

  // Trata o 422 de quantidade máxima: se conhecemos o teto de estoque do variant
  // (data-inventory-max), re-adiciona só o disponível (teto − já no carrinho).
  // Resolve com { response, partial } no sucesso parcial ou null se nada pôde
  // ser adicionado (com feedback já exibido).
  function recoverFromMaxQty(variantId, button, cart) {
    var maxAttr = button.getAttribute('data-inventory-max');
    // Sem teto conhecido (venda sem limite ou erro de outra natureza): mantém
    // o feedback genérico e não tenta re-adicionar.
    if (maxAttr === null) {
      flash(button, 'Indisponível');
      return Promise.resolve(null);
    }
    var maxTotal = parseInt(maxAttr, 10);
    if (isNaN(maxTotal) || maxTotal <= 0) {
      flash(button, 'Indisponível');
      return Promise.resolve(null);
    }
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cartData) {
        var addable = maxTotal - inCartQty(cartData, variantId);
        if (addable <= 0) {
          flash(button, 'Máximo no carrinho', 1800);
          return null;
        }
        return performAdd(variantId, addable, cart).then(function (resp) {
          // Corrida: estoque caiu ainda mais entre o /cart.js e o re-add.
          if (!resp || resp.status) {
            flash(button, 'Indisponível');
            return null;
          }
          // Sucesso parcial: transporta a qty efetiva fora do payload do Shopify
          // (não mutar `resp`, que é passado a renderContents).
          return { response: resp, partial: addable };
        });
      });
  }

  function onAddSuccess(response, partialQty, variantId, cart, button, input) {
    // publica cart-update (atualiza contagem) e abre a gaveta
    try {
      if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
        window.publish(window.PUB_SUB_EVENTS.cartUpdate, {
          source: 'mc-quick-add',
          productVariantId: variantId,
          cartData: response,
        });
      }
    } catch (e) { /* noop */ }

    if (cart && typeof cart.renderContents === 'function') {
      if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
      cart.renderContents(response);
    }
    if (input) input.value = '1';
    if (partialQty) {
      // Adicionou menos do que o pedido: avisa quantas unidades entraram.
      flash(button, 'Adicionado ' + partialQty, 1800);
    } else {
      button.textContent = button.dataset.mcLabel || button.textContent;
    }
    // atualiza os badges "N no carrinho" (a resposta do /cart/add não traz
    // o carrinho completo; busca o estado atual via /cart.js)
    syncCartBadges(null);
  }

  function addToCart(card, button) {
    var variantId = button.getAttribute('data-variant-id');
    if (!variantId) return;
    var input = qtyInput(card);
    var qty = input ? clampQty(input) : 1;

    if (button.dataset.loading === '1') return;
    button.dataset.loading = '1';
    button.dataset.mcLabel = button.textContent;
    button.textContent = 'Adicionando…';
    button.classList.add('is-loading');

    var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');

    performAdd(variantId, qty, cart)
      .then(function (response) {
        // 422 (qty pedida > disponível): tenta adicionar só o que cabe.
        // recoverFromMaxQty resolve com { response, partial } ou null.
        if (response && response.status) {
          return recoverFromMaxQty(variantId, button, cart);
        }
        return { response: response, partial: 0 };
      })
      .then(function (result) {
        if (!result) return; // erro já tratado / nada a adicionar
        onAddSuccess(result.response, result.partial, variantId, cart, button, input);
      })
      .catch(function () {
        button.textContent = button.dataset.mcLabel || button.textContent;
      })
      .finally(function () {
        button.dataset.loading = '';
        button.classList.remove('is-loading');
      });
  }

  document.addEventListener('click', function (e) {
    var step = e.target.closest('[data-mc-step]');
    if (step) {
      e.preventDefault();
      var stepper = step.closest('[data-mc-stepper]');
      var input = stepper ? stepper.querySelector('[data-mc-qty]') : null;
      if (input) {
        var delta = parseInt(step.getAttribute('data-mc-step'), 10) || 0;
        var v = (parseInt(input.value, 10) || 1) + delta;
        if (v < 1) v = 1;
        input.value = String(v);
      }
      return;
    }

    var addBtn = e.target.closest('[data-mc-add]');
    if (addBtn) {
      e.preventDefault();
      addToCart(addBtn.closest('[data-mc-product-card]'), addBtn);
    }
  });

  // Evita que Enter no input de qty submeta algum form ancestral
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target.matches && e.target.matches('[data-mc-qty]')) {
      e.preventDefault();
    }
  });

  // Mantém os badges em sincronia com remoções/alterações na gaveta e outras
  // origens (o valor inicial já vem renderizado server-side pelo Liquid).
  if (typeof window.subscribe === 'function') {
    window.subscribe('cart-update', syncCartBadges);
  }
})();
